const LARGURA = 1200
const ALTURA = 1600
const COR_PRIMARIA = "#E02041"
const COR_ESCURA = "#1A1A1D"
const COR_CLARA = "#F5F5F5"

function desenharRetanguloArredondado(context, x, y, largura, altura, raio) {
    context.beginPath()
    context.moveTo(x + raio, y)
    context.arcTo(x + largura, y, x + largura, y + altura, raio)
    context.arcTo(x + largura, y + altura, x, y + altura, raio)
    context.arcTo(x, y + altura, x, y, raio)
    context.arcTo(x, y, x + largura, y, raio)
    context.closePath()
}

function carregarImagem(src, comCors, nome) {
    return new Promise(resolve => {
        if (!src) {
            if (nome) console.warn(`[arte-qrcode] ${nome}: URL vazia, logo não será desenhado.`)
            resolve(null)
            return
        }
        const img = new Image()
        if (comCors) img.crossOrigin = "anonymous"
        img.onload = () => resolve(img)
        img.onerror = () => {
            if (nome) {
                console.warn(
                    `[arte-qrcode] ${nome}: falha ao carregar "${src}" (provável bloqueio de CORS no servidor da imagem). Logo não será desenhado.`
                )
            }
            resolve(null)
        }
        img.src = comCors ? `${src}${src.includes("?") ? "&" : "?"}_cache=${Date.now()}` : src
    })
}

function desenharIconeWifi(context, cx, cy) {
    context.strokeStyle = "#fff"
    context.lineWidth = 6
    context.lineCap = "round"
    for (let i = 0; i < 3; i++) {
        const raio = 12 + i * 11
        context.beginPath()
        context.arc(cx, cy + 6, raio, Math.PI * 1.2, Math.PI * 1.8)
        context.stroke()
    }
    context.fillStyle = "#fff"
    context.beginPath()
    context.arc(cx, cy + 6, 5, 0, Math.PI * 2)
    context.fill()
}

function desenharIconeCamera(context, cx, cy) {
    context.fillStyle = "#fff"
    desenharRetanguloArredondado(context, cx - 30, cy - 18, 60, 42, 8)
    context.fill()
    context.fillRect(cx - 12, cy - 30, 24, 12)
    context.fillStyle = COR_ESCURA
    context.beginPath()
    context.arc(cx, cy + 4, 13, 0, Math.PI * 2)
    context.fill()
    context.fillStyle = "#fff"
    context.beginPath()
    context.arc(cx, cy + 4, 8, 0, Math.PI * 2)
    context.fill()
}

function desenharIconeCheck(context, cx, cy) {
    context.strokeStyle = "#fff"
    context.lineWidth = 8
    context.lineCap = "round"
    context.lineJoin = "round"
    context.beginPath()
    context.moveTo(cx - 22, cy)
    context.lineTo(cx - 6, cy + 18)
    context.lineTo(cx + 24, cy - 20)
    context.stroke()
}

function desenharCirculoIcone(context, cx, cy, desenhaIcone) {
    context.fillStyle = COR_ESCURA
    context.beginPath()
    context.arc(cx, cy, 45, 0, Math.PI * 2)
    context.fill()
    desenhaIcone(context, cx, cy)
}

function quebrarTexto(context, texto, larguraMaxima) {
    const palavras = texto.split(" ")
    const linhas = []
    let linhaAtual = ""
    palavras.forEach(palavra => {
        const tentativa = linhaAtual ? `${linhaAtual} ${palavra}` : palavra
        if (context.measureText(tentativa).width > larguraMaxima && linhaAtual) {
            linhas.push(linhaAtual)
            linhaAtual = palavra
        } else {
            linhaAtual = tentativa
        }
    })
    if (linhaAtual) linhas.push(linhaAtual)
    return linhas
}

export async function gerarArteQrCode({
    mesa,
    qrDataUrl,
    nomeEstabelecimento,
    urlLogoClienteFiel,
    wifiNome,
    wifiSenha,
}) {
    const canvas = document.createElement("canvas")
    canvas.width = LARGURA
    canvas.height = ALTURA
    const context = canvas.getContext("2d")

    const [qrImagem, logoClienteFielImagem] = await Promise.all([
        carregarImagem(qrDataUrl, false, "QR code"),
        carregarImagem(urlLogoClienteFiel, true, "Logo Cliente Fiel"),
    ])

    // fundo
    context.fillStyle = "#fff"
    context.fillRect(0, 0, LARGURA, ALTURA)

    // cabeçalho
    context.fillStyle = COR_PRIMARIA
    context.fillRect(0, 0, LARGURA, 110)
    context.fillStyle = "#fff"
    context.textAlign = "left"
    context.font = "bold 52px Arial"
    context.fillText("FAÇA SEU PEDIDO", 40, 70)

    if (nomeEstabelecimento) {
        context.font = "28px Arial"
        context.textAlign = "left"
        context.fillStyle = "#fff"
        const nomeLinhas = quebrarTexto(context, nomeEstabelecimento, 640)
        context.fillText(nomeLinhas[0], 42, 100)
    }

    desenharRetanguloArredondado(context, 970, 15, 190, 80, 10)
    context.fillStyle = COR_ESCURA
    context.fill()
    context.fillStyle = "#fff"
    context.textAlign = "center"
    context.font = "bold 22px Arial"
    context.fillText("MESA", 1065, 45)
    context.font = "bold 40px Arial"
    context.fillText(String(mesa), 1065, 85)

    // QR code + moldura
    const qrX = 60
    const qrY = 170
    const qrTamanho = 470
    if (qrImagem) context.drawImage(qrImagem, qrX, qrY, qrTamanho, qrTamanho)

    context.strokeStyle = COR_PRIMARIA
    context.lineWidth = 10
    const cantoTamanho = 60
    const desenharCanto = (x, y, dx, dy) => {
        context.beginPath()
        context.moveTo(x, y + cantoTamanho * dy)
        context.lineTo(x, y)
        context.lineTo(x + cantoTamanho * dx, y)
        context.stroke()
    }
    desenharCanto(qrX - 15, qrY - 15, 1, 1)
    desenharCanto(qrX + qrTamanho + 15, qrY - 15, -1, 1)
    desenharCanto(qrX - 15, qrY + qrTamanho + 15, 1, -1)
    desenharCanto(qrX + qrTamanho + 15, qrY + qrTamanho + 15, -1, -1)

    desenharRetanguloArredondado(context, qrX, qrY + qrTamanho + 40, qrTamanho, 90, 10)
    context.fillStyle = COR_PRIMARIA
    context.fill()
    context.fillStyle = "#fff"
    context.textAlign = "center"
    context.font = "bold 24px Arial"
    context.fillText("APONTE A CÂMERA DO SEU CELULAR", qrX + qrTamanho / 2, qrY + qrTamanho + 75)
    context.fillText("E CONFIRA NOSSO CARDÁPIO", qrX + qrTamanho / 2, qrY + qrTamanho + 108)

    // tutorial (lado direito)
    const passos = []
    if (wifiNome || wifiSenha) {
        passos.push({
            icone: desenharIconeWifi,
            titulo: "Conecte-se à rede Wi-Fi",
            detalhes: [
                wifiNome ? `Rede: ${wifiNome}` : null,
                wifiSenha ? `Senha: ${wifiSenha}` : null,
            ].filter(Boolean),
        })
    }
    passos.push({
        icone: desenharIconeCamera,
        titulo: "Abra a câmera do celular",
        detalhes: ["e leia o QR code"],
    })
    passos.push({
        icone: desenharIconeCheck,
        titulo: "Pronto!",
        detalhes: ["Agora é só fazer seu pedido"],
    })

    const colunaX = 660
    const alturaDisponivel = 640
    const alturaPasso = alturaDisponivel / passos.length
    passos.forEach((passo, index) => {
        const centroY = 170 + alturaPasso * index + alturaPasso / 2
        desenharCirculoIcone(context, colunaX, centroY, passo.icone)

        context.textAlign = "left"
        context.fillStyle = COR_ESCURA
        context.font = "bold 30px Arial"
        context.fillText(passo.titulo, colunaX + 65, centroY - 4)

        context.font = "24px Arial"
        context.fillStyle = "#555"
        passo.detalhes.forEach((linha, i) => {
            context.fillText(linha, colunaX + 65, centroY - 4 + 34 * (i + 1))
        })
    })

    // faixa "Cardápio Digital"
    context.fillStyle = COR_ESCURA
    context.fillRect(0, 940, LARGURA, 300)
    context.textAlign = "center"
    context.fillStyle = "#fff"
    context.font = "bold 90px Arial"
    context.fillText("Cardápio", LARGURA / 2, 1070)
    context.fillStyle = COR_PRIMARIA
    context.fillText("Digital", LARGURA / 2, 1170)

    // rodapé
    context.fillStyle = COR_CLARA
    context.fillRect(0, 1240, LARGURA, ALTURA - 1240)

    desenharRetanguloArredondado(context, 80, 1290, LARGURA - 160, 140, 20)
    context.fillStyle = COR_PRIMARIA
    context.fill()
    context.fillStyle = "#fff"
    context.textAlign = "center"
    context.font = "bold 40px Arial"
    context.fillText("Escaneie e peça direto do celular,", LARGURA / 2, 1350)
    context.fillText("sem precisar esperar o garçom", LARGURA / 2, 1400)

    if (logoClienteFielImagem) {
        context.font = "22px Arial"
        context.fillStyle = "#888"
        context.textAlign = "center"
        context.fillText("Tecnologia", LARGURA / 2, 1480)
        const larguraMaxima = 220
        const alturaMaxima = 80
        const proporcao = Math.min(
            larguraMaxima / logoClienteFielImagem.width,
            alturaMaxima / logoClienteFielImagem.height
        )
        const largura = logoClienteFielImagem.width * proporcao
        const altura = logoClienteFielImagem.height * proporcao
        context.drawImage(logoClienteFielImagem, LARGURA / 2 - largura / 2, 1500, largura, altura)
    }

    return canvas.toDataURL("image/png")
}
